import {setLocale} from '@yandex-delivery/blocks/legacy/locale'
import {RumTimeMark, sendRumTimeMark} from '@yandex-delivery/modules/rum'
import {applyPolyfills as initApp} from '@yandex-delivery/polyfills'
import {raise} from '@yandex-delivery/utils'
import React from 'react'
import {type Root, createRoot} from 'react-dom/client'

import {App} from './app/ClientApp'
import {__ROOT_NODE__, appConfig} from './shared/config'

function getRootNode(): HTMLElement {
  return (
    document.getElementById(__ROOT_NODE__) ||
    raise(`[app] can't find container="${__ROOT_NODE__}"`)
  )
}

function renderRoot(root: Root) {
  root.render(<App />)
}

sendRumTimeMark(RumTimeMark.BEFORE_JS_FRAMEWORK_INIT)
void initApp()
  .then(() => setLocale(appConfig.lang))
  .then(getRootNode)
  .then(createRoot)
  .then(renderRoot)
  .then(() => sendRumTimeMark(RumTimeMark.REACT_INITED))
sendRumTimeMark(RumTimeMark.JS_FRAMEWORK_INITED)
